import { parseFormula, FormulaParseError } from 'shared/formula'
import type { CatalogField } from './types'

export const FORMULA_FUNCTIONS = [
  'CASE', 'WHEN', 'THEN', 'ELSE', 'END', 'IF',
  'CONCAT', 'LOWER', 'UPPER', 'TRIM', 'REPLACE', 'LEFT', 'RIGHT', 'SUBSTR', 'LENGTH',
  'REGEXP_EXTRACT', 'REGEXP_MATCH', 'REGEXP_REPLACE',
  'YEAR', 'MONTH', 'DAY', 'WEEK', 'DATE_DIFF', 'FORMAT_DATE',
  'CONTAINS', 'STARTS_WITH', 'ENDS_WITH', 'AND', 'OR', 'NOT',
]

export interface FormulaError {
  message: string
  position: number
}

export function getFormulaError(value: string): FormulaError | null {
  if (!value.trim()) return null
  try {
    parseFormula(value)
    return null
  } catch (e) {
    if (e instanceof FormulaParseError) return { message: e.message, position: e.position }
    return { message: (e as Error).message ?? 'Formule invalide', position: 0 }
  }
}

export function slugify(name: string): string {
  return name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
}

export interface Completion {
  label: string
  type: string
  detail?: string
}

export function buildCompletions(fields: CatalogField[]): Completion[] {
  return [
    ...FORMULA_FUNCTIONS.map((label) => ({ label, type: 'function' })),
    ...fields.map((f) => ({ label: f.key, type: 'variable', detail: f.label })),
  ]
}
